
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TextInput',
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    label: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      required: true
    },
    inputWidth: {
      type: String,
      default: 'small'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    cascadeInput: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modelValue: {
      get(): string | number {
        return this.value
      },
      set(value: string | number) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    triggerBlur(ev: InputEvent): void {
      this.$emit('blur', ev)
    }
  }
})
